export default {
  how_to_place_order: {
    header: 'Cum plasez o comandă?',
    body: 'Răsfoiți meniul, adăugați produse în coș și urmați pașii. Veți primi o confirmare odată ce comanda este plasată.',
  },
  schedule_order: {
    header: 'Pot programa o comandă în avans?',
    body: 'Da! La checkout, alegeți opțiunea „Programare" pentru a seta un timp de ridicare viitor.',
  },
  customize_order: {
    header: 'Pot personaliza comanda?',
    body: 'Da. Apăsați pe un produs din meniu pentru a vedea opțiunile de personalizare: toppinguri, garnituri și preferințe.',
  },
  track_order: {
    header: 'Cum îmi urmăresc comanda?',
    body: 'După plasarea comenzii, veți vedea actualizări în timp real în aplicație — de la confirmare la pregătire și ridicare.',
  },
  cancel_or_edit_order: {
    header: 'Pot anula sau modifica comanda după plasare?',
    body: 'Dacă comanda nu a început să fie pregătită, puteți solicita modificări sunând restaurantul direct din aplicație.',
  },
  payment_methods: {
    header: 'Ce metode de plată acceptați?',
    body: 'Acceptăm carduri de credit/debit principale, Apple Pay și Google Pay, în funcție de dispozitiv.',
  },
  no_confirmation: {
    header: 'Nu am primit o confirmare. Ce ar trebui să fac?',
    body: 'Verificați folderul de spam sau fila Comenzi din aplicație. Dacă tot nu o găsiți, contactați restaurantul direct.',
  },
  pickup_instructions: {
    header: 'De unde îmi ridic comanda?',
    body: 'Instrucțiunile de ridicare sunt pe ecranul de confirmare și în rezumatul comenzii. Căutați indicatoarele sau întrebați personalul.',
  },
  loyalty_points: {
    header: 'Pot acumula puncte de fidelitate cu comenzile mele?',
    body: 'Da, achizițiile eligibile acumulează automat puncte. Vedeți soldul și recompensele pe ecranul principal al aplicației.',
  },
  apply_promo_code: {
    header: 'Cum aplic un cod promoțional sau o reducere?',
    body: 'La checkout, veți vedea opțiunea de a introduce un cod promoțional. Reducerile disponibile sunt aplicate automat dacă sunteți eligibil.',
  },
  issue_with_order: {
    header: 'Ce fac dacă am o problemă cu comanda?',
    body: 'Suntem aici să ajutăm. Contactați restaurantul prin aplicație sau trimiteți un email la asistență prin opțiunea Contactați asistența.',
  },
  use_loyalty_and_coupon: {
    header: 'Pot folosi puncte de fidelitate și un cupon (gen Cumpără 1, Primești 1 Gratuit) la aceeași comandă?',
    body: 'Nu — o singură reducere sau ofertă poate fi aplicată per comandă. Aceasta asigură utilizarea corectă a recompenselor. Alegeți opțiunea cu cel mai bun raport calitate-preț!',
  },
};
